<div class="w-full h-full bg-gray-100">
    <!-- <ng-container *ngIf="apiLoaded | async"> -->
        <google-map height="100%" width="100%" [options]="options" (mapClick)="click($event)">
        </google-map>
    <!-- </ng-container> -->
</div>